import { render, staticRenderFns } from "./AssignCollector.vue?vue&type=template&id=7580d476&"
import script from "./AssignCollector.vue?vue&type=script&lang=js&"
export * from "./AssignCollector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports